var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"text-center pt-5",attrs:{"id":"header"}},[_c('div',[_c('h1',[_c('img',{attrs:{"src":require("../assets/logo.png"),"alt":"WBA"},on:{"click":function($event){return _vm.toHome()}}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }